const initialState = false;

const ReservationTransactionSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationTransactionSave":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationTransactionSaveReducer;
